import styled from 'styled-components';

interface IContainerProps {
  $showInputSearch: boolean;
}
export const Container = styled.div<IContainerProps>`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  justify-content: ${(props) =>
    props.$showInputSearch ? 'space-between' : 'flex-end'};
  align-items: flex-start;
  padding: 16px 18px;
  border-radius: 20px;
  border: 1px solid rgba(24, 90, 66, 0.08);
  background: rgba(255, 255, 255, 0.74);
  backdrop-filter: blur(8px);
`;

export const ContainerFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ContainerOptions = styled.div`
  display: flex;
  gap: 8px;
  margin-left: auto;
  flex-wrap: wrap;
`;

export const ContainerReports = styled.div`
  margin-left: 0;
`;
